import {Spin} from "antd";
import {t} from "i18next";
import React from "react";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import DataGroup from "./data-group";
import DataScope from "./data-scope";
import useDetailDataGroup from "./detail-data-group.hooks";
import {BackIcon} from "../../../../asset";
import ManagementHistory from "../../../../component/management-history/management-history";
import HeaderManagementHistory from "../../../../component/header-management-history/header-management-history";

const DetailDataGroup = () => {
    const {
        data,
        tab1,
        tab2,
        onChangeTab,
        handleBack,
        loading,
        toEdit,
        userManagementOpen,
        setUserManagementOpen,
        convertTimestamp
    } = useDetailDataGroup();

    return (
        <>
            <div className=" p-5 h-fit">
                <Breadcumbs
                    jmlLevel={4}
                    menuLevel1={`Admin`}
                    menuLevel2={`User Management`}
                    menuLevel3={`Data Group`}
                    menuLevel4={`Detail ${data?.id} - ${data?.data_group_id}`}
                />
                {loading ? (
                    <Spin className="mt-5"/>
                ) : (
                    <>
                        <div className='flex items-center justify-between my-[31px]'>
                            <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => handleBack()}>
                                <img src={BackIcon} alt=""/>
                                <h1 className='font-sans-bold text-2xl'
                                    id='title'>{`Detail ${data?.id} - ${data?.data_group_id}`}</h1>
                            </div>

                            <HeaderManagementHistory
                                data={data}
                                setUserManagementOpen={setUserManagementOpen}
                            />
                        </div>

                        <div className=" bg-white-100 p-5 rounded-[10px] min-h-[500px]">
                            <div className=" flex h-[52px] flex-row">
                                <p
                                    className={
                                        tab1
                                            ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer`
                                            : `text-gray-100 font-roboto text-2xl font-medium cursor-pointer`
                                    }
                                    onClick={() => onChangeTab(1)}
                                >
                                    Detail Data Group
                                </p>
                                <p
                                    className={
                                        tab2
                                            ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer ml-2`
                                            : `text-gray-100 font-roboto text-2xl font-medium ml-2 cursor-pointer`
                                    }
                                    onClick={() => onChangeTab(2)}
                                >
                                    Set Data Scope
                                </p>
                            </div>
                            {tab1 ? <DataGroup/> : <DataScope/>}
                        </div>

                        <ManagementHistory
                            id={data?.id}
                            detail={data}
                            tableName={'data_group'}
                            userManagementOpen={userManagementOpen}
                            setUserManagementOpen={() => setUserManagementOpen(false)}
                        />
                    </>
                )}

            </div>
            <div className='flex flex-row-reverse gap-[16px] px-5 m-5'>
                <PrimaryButton action={toEdit} text={t("COMMON:BTN_EDIT")}/>
            </div>
        </>
    );
}

export default DetailDataGroup;
